import { SwiperSlide } from 'swiper/react';
import BannerCard from '@components/common/banner-card';
import Carousel from '@components/ui-old/carousel/carousel';
import { useWindowSize } from '@utils/use-window-size';
import { useSsrCompatible } from '@utils/use-ssr-compatible';
import { useMainSlidersQuery } from '@framework/content/get-main-sliders';
import HeroBlockSkeleton from '@components/ui-old/loaders/HeroBlockSkeleton';
const breakpoints = {
  '1500': {
    slidesPerView: 2
  },
  '0': {
    slidesPerView: 1
  }
};
const HeroBlock: React.FC = () => {
  const {
    width
  } = useSsrCompatible(useWindowSize(), {
    width: 0,
    height: 0
  });
  const {
    data,
    isLoading
  } = useMainSlidersQuery({
    limit: 5
  });
  if (isLoading) {
    return <HeroBlockSkeleton />;
  }
  return <div className='heroBannerOne relative max-w-[1920px] mb-5 md:mb-12 lg:mb-14 2xl:mb-16 mx-auto overflow-hidden px-4 md:px-8 2xl:px-0' data-sentry-component="HeroBlock" data-sentry-source-file="hero-block.tsx">
      <Carousel loop={true} breakpoints={breakpoints} centeredSlides={width < 1500 ? false : true} autoplay={{
      delay: 5000
    }} className='mx-0' buttonGroupClassName='hidden' pagination={{
      clickable: true
    }} data-sentry-element="Carousel" data-sentry-source-file="hero-block.tsx">
        {data?.map((banner: any) => <SwiperSlide className='carouselItem px-0 2xl:px-3.5' key={`banner--key-${banner?.id}`}>
            <BannerCard banner={banner} href={banner.linkUrl || null} />
          </SwiperSlide>)}
      </Carousel>
    </div>;
};
export default HeroBlock;